import { render, staticRenderFns } from "./CabinetHeader.vue?vue&type=template&id=6a42b7fe"
import script from "./CabinetHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./CabinetHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CabinetHeader.vue?vue&type=style&index=0&id=6a42b7fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports